import type { PropsWithChildren } from "react";
import { useCallback, useState } from "react";

import { readFromSessionStorage, writeToSessionStorage } from "common/utilities/sessionStorage";
import { sessionContext } from "context/session/sessionContext";
import type { SessionModel } from "context/session/sessionTypes";

export const SessionProvider = ({ children }: PropsWithChildren) => {
  const [value, setValue] = useState(readFromSessionStorage("si_session_state") ?? {});

  const updateSession = useCallback(
    (callback: (state: SessionModel) => SessionModel) =>
      setValue((state) => {
        const next = callback(state);
        writeToSessionStorage("si_session_state", next);
        return next;
      }),
    [],
  );

  return <sessionContext.Provider value={{ ...value, updateSession }}>{children}</sessionContext.Provider>;
};
